import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Pagination, Stack } from "@mui/material";
import { contentBoxStyle } from "../shared/Theme";
import RiskOverviewGraph from "../elements/CyberRisk/RiskOverviewGraph";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";
import RiskCard from "../elements/CyberRisk/RiskCard";
import RiskCardModal from "../elements/CyberRisk/RiskCardModal";
import ragService from "../services/ragService";
import companyService from "../services/companyService";
import AccountGuard from "../elements/Admin/AccountGuard";
import CompleteRagsModal from "../elements/CyberRisk/CompleteRagsModal";

const Rags = () => {
	
	let [ pagedRisks, setPagedRisks ] = useState([]);
	let [ selectedRisk, setSelectedRisk ] = useState(null);
	let [ risks, setRisks ] = useState(ragService.rags);
	let [ riskCounts, setRiskCounts ] = useState({red: 0, amber: 0, green: 0});
	let [ showCompleteRagsModel, setShowCompleteRagsModel ] = useState(false);
	
	const handleRiskReadMore = (risk) => {
		setSelectedRisk(risk);
	};
	
	const handleRiskCardModalClose = (updated = false) => {
		setSelectedRisk(null);
		if (updated) {
			setRisks(ragService.rags);
		}
	};
	
	const handlePaginationChange = (e, page) => {
		updatePagedRisks(page);
	};
	
	const updatePagedRisks = (page) => {
		let fromIndex = 0;
		let toIndex = 0;
	
		fromIndex = 10 * (page - 1);
		toIndex = (risks.length >= page * 10)? page * 10 : risks.length;
		
		const newPagedRisks = [];
		for (let i = fromIndex; i < toIndex; i++) {
			if (risks[i].severity <= 0) continue;
			newPagedRisks.push(risks[i]);
		}
		
		setPagedRisks(newPagedRisks);
	}
	
	useEffect(() => {
		setRiskCounts(ragService.ragCounts);
		
		let fromIndex = 0;
		let toIndex = (risks.length >= 10)? 10 : risks.length;
		
		const newPagedRisks = [];
		for (let i = fromIndex; i < toIndex; i++) {
			if (risks[i].severity <= 0) continue;
			newPagedRisks.push(risks[i]);
		}
		
		setPagedRisks(newPagedRisks);
	}, [risks]);
	
	useEffect(() => {
		companyService.onSelectCompany(() => {
			setRisks(ragService.rags);
		});
	}, []);
	
	const handleShowComplete = () => {
		setShowCompleteRagsModel(true);
	};
	
	const handleCompleteRagsModalClose = () => {
		setShowCompleteRagsModel(false);
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<AccountGuard requiredService="kynd"/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Cyber Risk"/>
				<Box sx={contentBoxStyle}>
					<Stack direction="column" spacing="2">
						<Stack direction="row" spacing="2" justifyContent="center" sx={{ marginBottom: "2em" }}>
							<RiskOverviewGraph
								value={riskCounts.red}
								total={50}
								label="items"
								size="15em"
								colorOverride="red"
							/>
							<RiskOverviewGraph
								value={riskCounts.amber}
								total={50}
								label="items"
								size="15em"
								colorOverride="amber"
							/>
						</Stack>
						{pagedRisks.length > 0 ?
							<Stack direction="column" justifyContent="center">
								<Grid container spacing={2} justifyContent="center">
									{pagedRisks.map((risk, index) => {
										return (
											<Grid item key={`risk_${index}`}>
												<RiskCard
													risk={risk}
													width={260}
													height={250}
													onReadMore={handleRiskReadMore}
												/>
											</Grid>
										);
									})}
								</Grid>
								<Box sx={{ width: "344px", margin: "1em auto" }}>
									<Pagination
										count={Math.floor((riskCounts.red + riskCounts.amber) / 10) + 1}
										onChange={handlePaginationChange}
									/>
								</Box>
								<Stack direction="row" justifyContent="flex-end">
									<Button
										onClick={handleShowComplete}
										sx={{
											width: "10em"
										}}
									>
										Show Complete
									</Button>
								</Stack>
							</Stack>
						: <React.Fragment/> }
						<CompleteRagsModal
							completedRags={ragService.completedRags}
							show={showCompleteRagsModel}
							onCompletedRagClick={(rag) => { handleRiskReadMore(rag); }}
							onClose={handleCompleteRagsModalClose}
						/>
						<RiskCardModal
							risk={selectedRisk}
							onClose={handleRiskCardModalClose}
						/>
					</Stack>
				</Box>
			</Box>
		</Box>
	);
}

export default Rags;
